import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type PointHistoryLog = {
  point_history_log_id?: number; // 포인트 내역 idx
  point_history_id?: number; // 배송/정기배송 idx
  user_id?: number; // 오더/예약 idx
  point?: number; // 렌탈 idx
  type?: number; // 쇼/브/매/지 idx
  parcel_service_id?: number; // 유저 idx
  rental_id?: number; // 조직 idx
  order_id?: number; // 포인트
  memo?: string; // 생성일
  created_at?: string; // 생성일
  updated_at?: string; // 생성일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] PointHistoryLog
   * --
   */
  getPointHistoryLogs: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_POINT_HISTORY_LOG, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] PointHistoryLog
   * --
   */
  getPointHistoryLog: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_POINT_HISTORY_LOG, {
        point_history_log_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] PointHistoryLog
   * --
   */
  createPointHistoryLog: async (body: PointHistoryLog) => {
    try {
      const res = await $http.post(APIConstant.CREATE_POINT_HISTORY_LOG, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] PointHistoryLog
   * --
   */
  updatePointHistoryLog: async (body: PointHistoryLog) => {
    try {
      const { point_history_log_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_POINT_HISTORY_LOG, {
        point_history_log_id: point_history_log_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] PointHistoryLog
   * --
   */
  deletePointHistoryLog: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_POINT_HISTORY_LOG, {
        point_history_log_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
